var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0176 1.53711L12.0527 0.572266C11.748 0.267578 11.3164 0.0898438 10.9102 0.0898438C10.5039 0.0898438 10.0723 0.267578 9.76758 0.572266L1.28711 9.05273C1.21094 9.10352 1.18555 9.17969 1.16016 9.25586L0.5 12.582C0.449219 12.8613 0.652344 13.0898 0.880859 13.0898C0.90625 13.0898 0.957031 13.0898 0.982422 13.0898L4.30859 12.4297C4.38477 12.4043 4.46094 12.3789 4.53711 12.3027L13.0176 3.82227C13.6523 3.1875 13.6523 2.17188 13.0176 1.53711ZM3.34375 8.16406L8.49805 2.98438L10.6055 5.0918L5.42578 10.2461H3.34375V8.16406ZM4.0293 11.6426L1.41406 12.1758L1.94727 9.56055L2.53125 8.97656V11.0586H4.61328L4.0293 11.6426ZM12.4336 3.23828L11.1895 4.50781L9.08203 2.42578L10.3516 1.15625C10.4785 1.00391 10.6816 0.902344 10.9102 0.902344C11.1387 0.902344 11.3418 1.00391 11.4941 1.15625L12.4336 2.0957C12.7637 2.42578 12.7637 2.93359 12.4336 3.23828Z",
    fill: "#646464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.eb518e5f.svg";
export { ForwardRef as ReactComponent };